window.Shopify = window.Shopify || {};
window.Shopify.title = document.querySelector("title")?.textContent || "Shop";

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("a");
  const currentHostname = window.location.hostname;
  links.forEach((link) => {
    if (link.hostname !== currentHostname) {
      link.setAttribute("target", "_blank");
    }
  });
});
